import { useEffect, useRef, useState } from "react";
import { RefreshCw } from "lucide-react";

const TRIGGER = 70;

export function PullToRefresh() {
  const [pull, setPull] = useState(0);
  const [busy, setBusy] = useState(false);
  const start = useRef(null);
  useEffect(() => {
    const down = (e) => {
      const blocked = e.target.closest?.("[role=dialog], [data-no-pull], input, textarea, .overflow-y-auto");
      start.current = window.scrollY <= 0 && !blocked && e.touches.length === 1 ? e.touches[0].clientY : null;
    };
    const move = (e) => {
      if (start.current === null) return;
      const d = e.touches[0].clientY - start.current;
      if (d <= 0 || window.scrollY > 0) { setPull(0); return; }
      setPull(Math.min(110, d * 0.5));
    };
    const up = () => {
      if (start.current === null) return;
      start.current = null;
      setPull((p) => {
        if (p >= TRIGGER) { setBusy(true); setTimeout(() => window.location.reload(), 250); return TRIGGER; }
        return 0;
      });
    };
    window.addEventListener("touchstart", down, { passive: true });
    window.addEventListener("touchmove", move, { passive: true });
    window.addEventListener("touchend", up);
    window.addEventListener("touchcancel", up);
    return () => {
      window.removeEventListener("touchstart", down); window.removeEventListener("touchmove", move);
      window.removeEventListener("touchend", up); window.removeEventListener("touchcancel", up);
    };
  }, []);
  if (!pull && !busy) return null;
  const ready = pull >= TRIGGER || busy;
  return (
    <div className="fixed left-1/2 z-[70] -translate-x-1/2 pointer-events-none" style={{ top: `calc(env(safe-area-inset-top) + ${pull - 30}px)`, transition: start.current === null ? "top 0.2s ease-out" : "none" }} data-testid="pull-to-refresh">
      <div className={`w-11 h-11 rounded-full bg-white shadow-lg border border-pink-100 flex items-center justify-center ${ready ? "text-rose-500" : "text-slate-400"}`}>
        <RefreshCw className={`w-5 h-5 ${busy ? "animate-spin" : ""}`} style={busy ? undefined : { transform: `rotate(${pull * 3}deg)` }} />
      </div>
      {!busy && <p className="mt-1 text-[11px] font-semibold text-slate-500 text-center whitespace-nowrap">{ready ? "Loslassen zum Aktualisieren" : "Ziehen zum Aktualisieren"}</p>}
    </div>
  );
}
